import Checkbox from 'components/checkbox/Checkbox'
import parse, { domToReact } from 'html-react-parser'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addEditDataAPI } from 'services/CRUDServices'
import { selecTemplate } from 'redux/printTemplate/printTemplateAction'

const Templates = () => {
  const dispatch = useDispatch()
  const [reRender, setReRender] = useState(false)

  const tempatesLocal = JSON.parse(localStorage.getItem('templates'))
  const [selectedTemplateId, setSelectedTemplateId] = useState(
    tempatesLocal.find((item) => item.isDefault === true)?.id
  )

  const { selectCustomer } = useSelector((state: any) => state?.userInfo)

  function handleSaveDefault(id: number) {
    const templateId = tempatesLocal.find((template) => template.id === id)?.id

    // addEditDataAPI(
    //   `/customer-api/customer/updatePrintTemplate/${selectCustomer.id}/${templateId}`,
    //   'post',
    //   {}
    // ).then(() => {
      const templateIndex = tempatesLocal.findIndex(
        (template) => template.id === id
      )

      if (templateIndex !== -1) {
        const updatedTemplates = tempatesLocal.map((template) => ({
          ...template,
          isDefault: false,
        }))
        updatedTemplates[templateIndex] = {
          ...updatedTemplates[templateIndex],
          isDefault: true,
        }
        localStorage.setItem('templates', JSON.stringify(updatedTemplates))
        setReRender((prev) => !prev)
      }
    // })
  }

  return (
    <>
      <div className='flex flex-wrap justify-center mt-6 p-2 gap-4 '>
        {tempatesLocal?.map(({ id, printGroup, title, html, isDefault }) => (
          <div
            key={id}
            onClick={() => dispatch(selecTemplate(id))}
            className={` border  rounded-xl p-4 w-[42rem]`}
          >
            <div className='flex justify-between'>
              <div className='flex  items-center flex-1'>
                {' '}
                <Checkbox
                  // wrapperClassName="w-auto !mb-0 border-none"
                  name='isDefault'
                  values={selectedTemplateId === id}
                  handleChange={() => {
                    setSelectedTemplateId(id)
                    handleSaveDefault(id)
                  }}
                 
                />
                <span> {title} </span>{' '}
                {selectedTemplateId === id && (
                  <span className=' text-[#EF5644] mr-2'> (قالب پیش فرض) </span>
                )}{' '}
              </div>
            </div>
            <p className=' text-sm  text-gray-400'>{printGroup?.text}</p>
            <div className='flex justify-center mt-4'>
              {parse(String(html), templateOptions)}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default Templates

export const templateOptions = {
  replace({ attribs, children }) {
    if (!attribs) {
      return
    }

    if (attribs.class && attribs.class === 'barcodeWrapper') {
      const cprNumber = 1000034544434
      return (
        <div className='barcodeWrapper '>
          {/* <Barcode width={2.8} height={60} value={cprNumber} displayValue={false} /> */}
        </div>
      )
    }
    if (attribs.class && attribs.class.includes('templates')) {
      const newClass = attribs.class.replace(/h-\[\d+(\.\d+)?cm\]/g, 'h-auto')

      return (
        <div className={newClass}>{domToReact(children, templateOptions)}</div>
      )
    }
  },
}
